module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"user_display_name":"这是 <b>%{name}</b> 的评论。"}}')
  delete Component.options._Ctor
}
